import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { publicApi, adminApi } from "../../lib/api";
import { toast } from "sonner";

export default function SettingsPage() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    publicApi.getSiteContent().then((r) => setForm(r.data)).catch(console.error);
  }, []);

  const updateField = (field, value) => setForm((f) => ({ ...f, [field]: value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await adminApi.updateSiteContent(form);
      toast.success("Site settings saved!");
    } catch (err) {
      toast.error("Error saving settings");
    } finally {
      setSaving(false);
    }
  };

  if (!form) return <div className="text-center py-16 text-slate-400">Loading settings...</div>;

  return (
    <div className="max-w-2xl">
      <h2 className="text-2xl font-bold text-slate-900 mb-6">Site Settings</h2>

      <div className="space-y-6">
        <Card className="border-slate-100">
          <CardContent className="p-6 space-y-4">
            <h3 className="font-semibold text-slate-800">Business Info</h3>
            <div className="space-y-1.5">
              <Label>Business Name</Label>
              <Input value={form.business_name || ""} onChange={(e) => updateField("business_name", e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label>WhatsApp Number (with country code, no +)</Label>
              <Input value={form.whatsapp_number || ""} onChange={(e) => updateField("whatsapp_number", e.target.value)} placeholder="919056382775" />
            </div>
            <div className="space-y-1.5">
              <Label>Location</Label>
              <Input value={form.location || ""} onChange={(e) => updateField("location", e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label>Instagram (Business)</Label>
              <Input
                value={form.instagram_business || ""}
                onChange={(e) => updateField("instagram_business", e.target.value)}
                placeholder="https://www.instagram.com/frostyware/"
              />
            </div>
            <div className="space-y-1.5">
              <Label>Instagram (Founder / Personal)</Label>
              <Input
                value={form.instagram_personal || ""}
                onChange={(e) => updateField("instagram_personal", e.target.value)}
                placeholder="https://www.instagram.com/abhijeetmakan/"
              />
            </div>
          </CardContent>
        </Card>

        <Card className="border-slate-100">
          <CardContent className="p-6 space-y-4">
            <h3 className="font-semibold text-slate-800">Hero Section</h3>
            <div className="space-y-1.5">
              <Label>Headline</Label>
              <Input value={form.hero_headline || ""} onChange={(e) => updateField("hero_headline", e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label>Subheadline</Label>
              <Input value={form.hero_subheadline || ""} onChange={(e) => updateField("hero_subheadline", e.target.value)} />
            </div>
          </CardContent>
        </Card>

        <Card className="border-slate-100">
          <CardContent className="p-6 space-y-4">
            <h3 className="font-semibold text-slate-800">Stats</h3>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <Label>Stat 1 Value</Label>
                <Input value={form.stat1_value || ""} onChange={(e) => updateField("stat1_value", e.target.value)} placeholder="500+" />
              </div>
              <div className="space-y-1.5">
                <Label>Stat 1 Label</Label>
                <Input value={form.stat1_label || ""} onChange={(e) => updateField("stat1_label", e.target.value)} placeholder="Projects Done" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <Label>Stat 2 Value</Label>
                <Input value={form.stat2_value || ""} onChange={(e) => updateField("stat2_value", e.target.value)} placeholder="100%" />
              </div>
              <div className="space-y-1.5">
                <Label>Stat 2 Label</Label>
                <Input value={form.stat2_label || ""} onChange={(e) => updateField("stat2_label", e.target.value)} placeholder="Customizable" />
              </div>
            </div>
          </CardContent>
        </Card>

        <Button onClick={handleSave} disabled={saving} className="bg-sky-500 hover:bg-sky-600 text-white w-full h-11 rounded-lg font-semibold">
          {saving ? "Saving..." : "Save Settings"}
        </Button>
      </div>
    </div>
  );
}
